import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'
import toUpper from 'lodash/toUpper'

import { RouteTicketProviderTickets } from 'routes'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 150px;
`

const TicketingSystemItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 8px 8px;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 127px;
  height: 127px;
  outline: none;
  cursor: pointer;
  opacity: 0.85;
  background-color: #FFFFFF;
  text-align: center;

  border: 1px solid ${colors.secondary80};
  filter: grayscale(100%);
  border-radius: 4px;

  &:hover {
    opacity: 1;
    border: 1px solid ${colors.primary40};
    filter: grayscale(0%);
  }
`

const StyledText = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.secondary40};
  line-height: 22px;
  width: 127px;
  text-align: center;
  padding-top: 11px;
`

const Image = styled.img`
  width: 104px;
`

const TicketProvidersList = ({ ticketProviders }) => {
  return (
    <StyledWrapper>
      {ticketProviders.map(ticketProvider => {
        return (
          <TicketingSystemItem key={ticketProvider.id}>
            <StyledLink
              to={RouteTicketProviderTickets({ ticketProviderId: ticketProvider.id })}
            >
              {ticketProvider.icon
                ? <Image src={ticketProvider.icon} />
                : <div>{toUpper(ticketProvider.name)}</div>
              }
            </StyledLink>
            <StyledText>{ticketProvider.name}</StyledText>
          </TicketingSystemItem>
        )
      }
      )}
    </StyledWrapper>
  )
}

TicketProvidersList.propTypes = {
  ticketProviders: PropTypes.array.isRequired,
}

export default TicketProvidersList
